import * as React from 'react';

type IconType = {
  strokeColor?: string;
  fillColor?: string;
};

export default (properties: IconType) => {
  const {strokeColor, fillColor} = properties;
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={fillColor ?? 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6667 10.8333C11.6667 12.6743 13.1591 14.1667 15 14.1667C16.8409 14.1667 18.3333 12.6743 18.3333 10.8333C18.3333 8.99238 16.8409 7.5 15 7.5C13.1591 7.5 11.6667 8.99238 11.6667 10.8333Z"
        fill={strokeColor ?? '#F4F3FD'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18.8331V19.4998C9 20.2361 9.59695 20.8331 10.3333 20.8331H19.6667C20.403 20.8331 21 20.2361 21 19.4998V18.8331C21 16.9921 19.5076 15.4998 17.6667 15.4998H12.3333C10.4924 15.4998 9 16.9921 9 18.8331Z"
        fill={strokeColor ?? '#F4F3FD'}
      />
      <path
        d="M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z"
        fill={strokeColor ?? '#F4F3FD'}
        strokeWidth="2"
      />
    </svg>
  );
};
